import ViewPlanArticles from "@components/health-insurance-plan/get-quote/ViewPlanArticles";
import ViewPlanGeneric from "@components/LeadForm/ViewPlanGeneric";
import ViewPlanTravel from "@components/LeadForm/ViewPlanTravel";
import { LeadFormTypes } from "./enums";

type DynamicLeadFormProps = {
    leadFormType: string;
    isds?: any;
};

const DynamicLeadForm = ({ leadFormType, isds }: DynamicLeadFormProps) => {
    switch (leadFormType) {
        case LeadFormTypes.TWO:
        case LeadFormTypes.THREE:
        case LeadFormTypes.CORPORATE:
        case LeadFormTypes.FIVE:
            return <ViewPlanGeneric isds={isds} leadFormType={leadFormType} />;
        
        case LeadFormTypes.TRAVEL:
            return <ViewPlanTravel />;

        case LeadFormTypes.SINGLE:
        default:
            return <ViewPlanArticles hideProgressBar newDesignConfig isds={isds} />;
    }
};

export default DynamicLeadForm;
